export const resizeObserver = (style: CSSStyleDeclaration) => new ResizeObserver((entries) => {
  entries.forEach((entry) => {
    const { width } = entry.contentRect;
    style.setProperty('--container-width', `${width}px`);
  });
});
